// extracted by mini-css-extract-plugin
module.exports = {"switch":"styles_switch__35YaJ","slider":"styles_slider__S38yf","round":"styles_round__hvU_Z","cardSwitch":"styles_cardSwitch__FNA9i"};